module.exports = __webpack_public_path__ + "static/racertrashmovies-a8aa271cca72e40bef61f2cc73425450.gif";